import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const CCDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Course And Certificate</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Couser Name</th>
                  <th>Abbreviation</th>
                  <th>Certificate No</th>
                  <th>Issued Date</th>
                  <th>Expiry Date</th>
                  <th>Remarks</th>
                  {/* <th>Document Image</th> */}
                </tr>
              </thead>
              <tbody>
                {employee?.certificationsDetails?.map((c) => (
                  <tr key={c.code}>
                    <td>{c.courseName}</td>
                    <td>{c.abbreviation}</td>
                    <td>{c.certificateNumber}</td>
                    <td>{c.issueDate !== null ? format(new Date(c.issueDate), "yyyy-MM-dd") : ""}</td>
                    <td>{c.expiryDate !== null ? format(new Date(c.expiryDate), "yyyy-MM-dd"): ""}</td>
                    <td>{c.remark}</td>
                    {/* <td>
                      {c.documentImage !== "" || c.documentImage !== null ? (
                        <img src={c.documentImage} />
                      ) : (
                        ""
                      )}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

CCDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default CCDetails;
